import { Fade, Typography } from '@material-ui/core'

import { getTranslate } from '../../localization'
import { CancelPolicy } from '../../types/cancelAndModifyPolicies'
import PolicyRowMobile from './PolicyRowMobile'
import PolicyRowMobileSkeleton from './PolicyRowMobile.skeleton'
import useStyles from './styles/PoliciesTable.styles'

interface PolicyTableMobileProps {
  loading: boolean
  data: CancelPolicy[]
  providerCode: string
}

export const PolicyTableMobile: React.FC<PolicyTableMobileProps> = ({
  loading,
  data,
  providerCode
}) => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      <div className={classes.tableHeadMobile}>
        <div className={classes.tableHeadCellMobile}>
          <Typography variant="body1">{getTranslate('Name')}</Typography>
        </div>
        <div />
      </div>
      {loading
        ? Array(5)
            .fill('')
            .map((item, index) => (
              <PolicyRowMobileSkeleton
                key={`accommodation-skeleton${item}${index.toString()}`}
              />
            ))
        : data.map((singlePolicy, index) => (
            <Fade in timeout={600} key={index}>
              <div>
                <PolicyRowMobile
                  providerCode={providerCode}
                  data={singlePolicy}
                />
              </div>
            </Fade>
          ))}
    </div>
  )
}
